export default __webpack_public_path__ + "static/img-map-112570baf8c59c1316cd6ecd66828b6a.png";